
export class CustomerCertification {
    public id: number;
    public customerNumberID: number;
    public customerCertificationTypeId: number;

    public certificationType: string;
    public certificateNumber: string;
    public description: string;
    public effectiveDate: any;
    public expirationDate: any;

    public updatedBy: string;
    public updatedDate: any;

    public viewId: number;
}
